import { Card, Row, Col, OverlayTrigger, Tooltip} from 'react-bootstrap';
import info from '../assets/images/info.png';

// Displays the project description in a series of cards

const ProjectDescription = ({ project, onClose }) => {
  const boldTextStyle = {
    fontWeight: "bold",
    margin: 0, // Remove default margins if any
  };

  const cardStyle = {
    borderRadius: 0, // Remove soft edges
  };

  // Tooltip for the bonus "i" icon
  const bonusTooltip = (
    <Tooltip id="bonus-tooltip">
      Clients have the possibility to set a “bonus” payment based on achieving specific criteria. The bonus is calculated as a percentage, over and above the contractual daily rate indicated in the contract.
    </Tooltip>
  );

  // Tooltip for the malus "i" icon
  const malusTooltip = (
    <Tooltip id="malus-tooltip">
      Clients can integrate a “malus” into the consultant’s contract. This works just like the bonus, but in the opposite direction.  If the client’s appreciation at the end of a period is that the consultant didn’t achieve the specific criteria, the malus, calculated as a percentage of the daily rate, is subtracted from the total periodic payment.
    </Tooltip>
  );

  return (
    <>

      <button className="back-button" onClick={onClose}>
        ←
      </button>

      <button className="share-button">
        <i className="fas fa-share"></i> Share
      </button>

      <button className="apply-button">Apply</button>
      {/* First row */}
      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Project title</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.title}</Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Second row */}
      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Sector</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.sectors.map((sector) => sector.name).join(", ")}</Card.Body>
          </Card>
        </Col>
      </Row>

      {/* <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Domain</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>??</Card.Body>
          </Card>
        </Col>
      </Row> */}

      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
        <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Practice</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.practices.map((practice) => practice.name).join(", ")}</Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
        <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Practice</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.cities.map((city) => city.name).join(", ")}</Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
        <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Remote work</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.remote_work}</Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Duration (days)</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.request_duration}</Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Success fee - bonus</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.success_fees_bonus}</Card.Body>
          </Card>
        </Col>
        <OverlayTrigger placement="right" overlay={bonusTooltip}>
                <img src={info} alt="info" style={{maxWidth:"40px", maxHeight:"40px", width: "auto", height:"auto"}} />
        </OverlayTrigger>
      </Row>

      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Success fee - malus</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.success_fees_malus}</Card.Body>
          </Card>
        </Col>
        <OverlayTrigger placement="right" overlay={malusTooltip}>
                <img src={info} alt="info" style={{maxWidth:"40px", maxHeight:"40px", width: "auto", height:"auto"}} />
        </OverlayTrigger>
      </Row>

      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Experience</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.experience_level}</Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Description</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>{project.request_description}</Card.Body>
          </Card>
        </Col>
      </Row>

      {/* <Row className="g-0" style={{ marginBottom: "5px" }}>
        <Col xs={2} style={{ paddingRight: "5px" }}>
          <Card style={{ ...cardStyle, backgroundColor: "#f2f2f2" }}>
            <Card.Body style={boldTextStyle}>Contact</Card.Body>
          </Card>
        </Col>
        <Col xs={6}>
          <Card style={cardStyle}>
            <Card.Body>??</Card.Body>
          </Card>
        </Col>
      </Row> */}
    </>
  );
};

export default ProjectDescription;
